"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Hooks = __importStar(require("preact/hooks"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var TopBarConsole = __importStar(require("./O_TopBarConsole"));
var ProductGroup = __importStar(require("./O_ProductGroup"));
var icons_1 = require("./icons");
var ModelsDrawer = __importStar(require("./D_ModelsDrawer"));
var Alert = __importStar(require("./A_Alert"));
var UploadModal = __importStar(require("./O_UploadCsvModal"));
var Component = function (p) {
    var refreshCopy = 'Refresh';
    var _a = Hooks.useState(false), isDrawerOpen = _a[0], setIsDrawerOpen = _a[1];
    var onRowClick = function (productId) {
        p.onSelectRow(productId);
        setIsDrawerOpen(true);
    };
    var onCloseClick = function () {
        p.onCloseDrawer();
        setIsDrawerOpen(false);
    };
    var _b = Hooks.useState(false), uploadModalVisible = _b[0], setUploadModalVisible = _b[1];
    var _c = Hooks.useState(false), uploadModalLoading = _c[0], setUploadModalLoading = _c[1];
    var _d = Hooks.useState(false), uploadCsvFailed = _d[0], setUploadCsvFailed = _d[1];
    var _e = Hooks.useState(false), uploadCsvSucceeded = _e[0], setUploadCsvSucceeded = _e[1];
    var _f = Hooks.useState(false), uploadCsvCompleted = _f[0], setUploadCsvCompleted = _f[1];
    var onCsv = function () { return setUploadModalVisible(true); };
    var onUploadCsv = function (f) { return __awaiter(void 0, void 0, void 0, function () {
        var succeeded;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setUploadModalLoading(true);
                    return [4 /*yield*/, p.onUploadCsv(f)];
                case 1:
                    succeeded = _a.sent();
                    setUploadModalLoading(false);
                    setUploadCsvCompleted(true);
                    succeeded ? setUploadCsvSucceeded(true) : setUploadCsvFailed(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var onCloseModal = function () {
        setUploadModalVisible(false);
        setUploadCsvCompleted(false);
        if (uploadCsvSucceeded)
            setUploadCsvSucceeded(false);
        if (uploadCsvFailed)
            setUploadCsvFailed(false);
    };
    var onTryAgain = function () {
        setUploadCsvFailed(false);
        setUploadCsvCompleted(false);
    };
    return (Preact.h(Box_1.default, { sx: {
            backgroundColor: '#FAFAFA',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
        } },
        Preact.h(TopBarConsole.Component, { logoUrl: "assets/FixtuurConsoleLogo.svg", secondaryButtonText: "Logout", secondaryButtonIcon: Preact.h(icons_1.LogoutIcon, null), primaryButtonText: "Model Checker", primaryAction: p.openModelChecker, primaryButtonIcon: Preact.h(icons_1.ModelCheckerIcon, null), refreshButtonCopy: refreshCopy, refreshButtonAction: p.refresh }),
        Preact.h(Box_1.default, { sx: {
                display: 'flex',
                height: '100%',
                overflowY: 'auto',
            } },
            Preact.h(ProductGroup.Component, { columns: p.columns, rows: p.rows, onRowClick: onRowClick, tenant: p.tenant, onCsvClick: onCsv }),
            p.selectedProductId && (Preact.h(ModelsDrawer.Component, { productId: p.selectedProductId, isOpen: isDrawerOpen, onModelStatusUpdate: p.onModelStatusUpdate, onCheckModel: p.onCheckModel, onAddModel: p.onAddModel, onDeleteModel: p.onDeleteModel, onCloseClick: onCloseClick, articleModels: p.articleModels, arModel: p.arModel, onFileUpload: p.onFileUpload, onFileDownload: p.onFileDownload })),
            Preact.h(Alert.Component, { color: "info", text: "Change made", buttonText: refreshCopy, buttonAction: p.alertAction, onCloseClick: p.onCloseAlert, show: p.showAlert, sx: { width: '377px' } }),
            Preact.h(UploadModal.Component, { show: uploadModalVisible, onFileReady: onUploadCsv, loading: uploadModalLoading, failed: uploadCsvFailed, succeeded: uploadCsvSucceeded, completed: uploadCsvCompleted, onCloseClick: onCloseModal, onTryAgainClick: onTryAgain }))));
};
exports.Component = Component;
